import type { ReactElement, ReactNode } from 'react';
import { Children, isValidElement } from 'react';

export function requireSingleReactElement(children: ReactNode): ReactElement {
    if (!isValidElement(children)) {
        throw new Error(
            `Expected a single React Element child, but got: ${Children.toArray(children)
                .map((child) =>
                    typeof child === 'object' && child !== null && 'type' in child
                        ? String((child as { type: unknown }).type)
                        : typeof child,
                )
                .join(', ')}`,
        );
    }
    return children;
}
